var CableBuilderFinish = function ($el) { 
    this.$el = $el
}

CableBuilderFinish.prototype.setup = function() {
    this.$el.trigger("steps-finished");
}
